/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ home: NonNullable<unknown>, homeScore: NonNullable<unknown>, away: NonNullable<unknown>, awayScore: NonNullable<unknown> }} Email_Game_SubjectInputs */

const th_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const en_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ja_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const zh_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const es_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const pt_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const id_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const fr_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const tl_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const vi_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ko_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const de_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ru_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const tr_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const it_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const pl_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const uk_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const hi_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ar_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ms_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const bn_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const zh_tw2_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const zh_hk2_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const ur_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const fa_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const sw_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

const nl_email_game_subject = /** @type {(inputs: Email_Game_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.home} ${i?.homeScore} – ${i?.away} ${i?.awayScore}`)
};

/**
* | output |
* | --- |
* | "{home} {homeScore} – {away} {awayScore}" |
*
* @param {Email_Game_SubjectInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_game_subject = /** @type {((inputs: Email_Game_SubjectInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Game_SubjectInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_game_subject(inputs)
	if (locale === "ja") return ja_email_game_subject(inputs)
	if (locale === "zh") return zh_email_game_subject(inputs)
	if (locale === "es") return es_email_game_subject(inputs)
	if (locale === "pt") return pt_email_game_subject(inputs)
	if (locale === "id") return id_email_game_subject(inputs)
	if (locale === "fr") return fr_email_game_subject(inputs)
	if (locale === "tl") return tl_email_game_subject(inputs)
	if (locale === "vi") return vi_email_game_subject(inputs)
	if (locale === "ko") return ko_email_game_subject(inputs)
	if (locale === "de") return de_email_game_subject(inputs)
	if (locale === "ru") return ru_email_game_subject(inputs)
	if (locale === "tr") return tr_email_game_subject(inputs)
	if (locale === "it") return it_email_game_subject(inputs)
	if (locale === "pl") return pl_email_game_subject(inputs)
	if (locale === "uk") return uk_email_game_subject(inputs)
	if (locale === "hi") return hi_email_game_subject(inputs)
	if (locale === "ar") return ar_email_game_subject(inputs)
	if (locale === "ms") return ms_email_game_subject(inputs)
	if (locale === "bn") return bn_email_game_subject(inputs)
	if (locale === "zh-TW") return zh_tw2_email_game_subject(inputs)
	if (locale === "zh-HK") return zh_hk2_email_game_subject(inputs)
	if (locale === "ur") return ur_email_game_subject(inputs)
	if (locale === "fa") return fa_email_game_subject(inputs)
	if (locale === "sw") return sw_email_game_subject(inputs)
	if (locale === "nl") return nl_email_game_subject(inputs)
	return en_email_game_subject(inputs)
});